import type Api from 'common/lib/api';

const getSupportApi = (api: Api) => ({
  createTicket: (data: FormData) => api.post('/support/create', { data }),
});

export default getSupportApi;
